import Vue from 'vue';
import Router from 'vue-router';
import VueSocketio from 'vue-socket.io';
import _ from 'lodash';
import Segment from '@/Segment';
import { io } from 'socket.io-client';
import store from '@/store';
import featureFlag from '@/api/featureFlag';
import LoginApi from '@/api/LoginApi';
import isDormantWinback from '@/utils/dormant-winback';
import EmailRendering from '@/pages/responsive-pages/EmailRendering';
import SavingZone from '@/pages/responsive-pages/authenticated/navigation-pages/saving-zone/SavingZone';
import SupermarketStory from '@/pages/responsive-pages/authenticated/navigation-pages/mid-month/supermarket-story/SupermarketStory';
import SupermarketStoryTeaser from '@/pages/responsive-pages/authenticated/navigation-pages/mid-month/supermarket-story/SupermarketStoryTeaser';
import Wrong2faAccountErrorScreen from '@/pages/responsive-pages/single-factor-authenticated/2fa-login/Wrong2faAccountErrorScreen';
import SharedPage from '@/pages/responsive-pages/non-authenticated/share/SharedPage';
import AmbassadorsPage from '@/pages/responsive-pages/authenticated/navigation-pages/ambassadors/AmbassadorsPage';
import ActiveChallengeRouter
  from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/ActiveChallengeRouter';
import auth0 from '@/utils/auth0';
import DDLogs from '@/DDLogs';
import MoneyMoonJoinPage from '@/pages/responsive-pages/authenticated/navigation-pages/money-moon/MoneyMoonJoinPage';
import RiseupGiftcardFlow from '@/pages/responsive-pages/authenticated/navigation-pages/riseup-giftcard/RiseupGiftcardFlow';
import SuperDiscountPage from '@/pages/responsive-pages/authenticated/navigation-pages/super-discount/SuperDiscountPage';
import UrlRedirect from '@/pages/responsive-pages/UrlRedirect';
import AuthenticateToken from '../pages/responsive-pages/authenticated/AuthenticateToken.vue';
import Complete2faLogin from '../pages/responsive-pages/single-factor-authenticated/2fa-login/Complete2faLoginScreen';
import Done2FAScreen from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faLoginDone.vue';
import TwoFactorMigration from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faMigration';
import LoginWithGoogleOnFacebook from '../pages/responsive-pages/single-factor-authenticated/2fa-login/LoginWithGoogleInFacebookBrowser';
import ResetPassword from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faResetPassword';
import ResetPasswordSent from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faResetPasswordSent';
import ResetPasswordDone from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faResetPasswordDone';
import ResetPasswordLinkExpired from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faResetPasswordExpiredLink';
import ResetPasswordError from '../pages/responsive-pages/single-factor-authenticated/2fa-login/2faResetPasswordError';
import InviteAuthenticateToken from '../pages/responsive-pages/invite-authenticated/InviteAuthenticateToken.vue';
import SingleFactorAuthenticateToken from '../pages/responsive-pages/single-factor-authenticated/SingleFactorAuthenticateToken.vue';
import SuspiciousGroupJoinInvestigator from '../pages/responsive-pages/authenticated/suspicious-group-join/SuspiciousGroupJoinInvestigator.vue';
import CredentialsSettings from '../pages/responsive-pages/authenticated/navigation-pages/credentials-settings/CredentialsSettings.vue';
import Settings from '../pages/responsive-pages/authenticated/navigation-pages/settings/Settings.vue';
import PersonalInformation from '../pages/responsive-pages/authenticated/navigation-pages/settings/PersonalInformation.vue';
import TransactionStories from '../pages/responsive-pages/authenticated/navigation-pages/transaction-stories/TransactionStories.vue';
import OnboardFlow from '../pages/responsive-pages/authenticated/onboard2/OnboardFlow.vue';
import CashflowApp from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/CashflowApp.vue';
import CashflowTourFlow from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-tour/CashflowTourFlow';
import DemoCashflowApp from '../pages/responsive-pages/authenticated/navigation-pages/cashflow-app/DemoCashflowApp.vue';
import PocketMoney from '../pages/responsive-pages/non-authenticated/pocket-money/PocketMoney';
import BalancePage from '../pages/responsive-pages/authenticated/navigation-pages/balance/BalancePage.vue';
import SignupFlow from '../pages/responsive-pages/non-authenticated/wine-and-dine/signup/SignupFlow.vue';
import SignupFlowV3 from '../pages/responsive-pages/non-authenticated/wine-and-dine/signup-v3/SignupFlowV3';
import SignupFlowV2 from '../pages/responsive-pages/non-authenticated/wine-and-dine/signup-v2/SignupFlowV2';
import SignupFlowV1 from '../pages/responsive-pages/non-authenticated/wine-and-dine/signup-v1/SignupFlowV1';
import LeadQualificationSurvey from '../pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/LeadQualificationFlow.vue';
import NPSSurveyFlow from '../pages/responsive-pages/authenticated/survey/NPS/NPSSurveyFlow.vue';
import ActivationSurvey from '../pages/responsive-pages/authenticated/survey/activation-survey/ActivationSurvey';
import CSATSurvey from '../pages/responsive-pages/authenticated/survey/csat-survey/CSATSurvey.vue';
import Survey from '../pages/responsive-pages/authenticated/survey/Survey.vue';
import Playground from '../pages/base-ui-playground/Playground.vue';
import UnsupportedBanksMessagePage from '../pages/responsive-pages/authenticated/unsupported-banks/UnsupportedBanksMessagePage.vue';
import AppHeader from '../base-components/app-header/AppHeader.vue';
import ResponsivePage from '../pages/responsive-pages/ResponsivePage.vue';
import StateRouter from '../pages/responsive-pages/authenticated/routing/StateRouter.vue';
import DiscountLandingPage from '../pages/responsive-pages/non-authenticated/discount-api/DiscountLandingPage.vue';
import LoadingOBKCredentials from '../pages/responsive-pages/non-authenticated/open-banking/LoadingOBKCredentials.vue';
import SubscriptionFlow from '../pages/responsive-pages/authenticated/subscription/SubscriptionFlow.vue';
import DiscountConnectionApprovedPage from '../pages/responsive-pages/non-authenticated/discount-api/DiscountConnectionApprovedPage.vue';
import PopupsManager from '../base-components/app-header/PopupsManager.vue';
import ChurnSurveyFlow from '../pages/responsive-pages/non-authenticated/churn/ChurnSurveyFlow.vue';
import AccountSettings from '../pages/responsive-pages/authenticated/navigation-pages/account-settings/AccountSettings.vue';
import LoginEnterPhoneNumber from '../pages/responsive-pages/non-authenticated/login/LoginEnterPhoneNumber.vue';
import LoginEnterCode from '../pages/responsive-pages/non-authenticated/login/LoginEnterCode.vue';
import LoginAs from '../pages/responsive-pages/non-authenticated/login/LoginAs.vue';
import config from '../config';
import WineAndDineFlow from '../pages/responsive-pages/non-authenticated/wine-and-dine/WineAndDineFlow.vue';
import FinishLQ from '../pages/responsive-pages/non-authenticated/wine-and-dine/lead-qualification/FinishLQ.vue';
import InviteMember from '../pages/responsive-pages/authenticated/InviteMember.vue';
import OpenBankingLandingPage from '../pages/responsive-pages/non-authenticated/open-banking/OpenBankingLandingPage';
import CustomersApi from '../api/CustomersApi';
import MonthReviewFlowWrapper from '../pages/responsive-pages/authenticated/navigation-pages/month-review/MonthReviewFlowWrapper';
import Signup2faDoneScreen from '../pages/responsive-pages/single-factor-authenticated/2fa-login/Signup2faDoneScreen';
import TelecomStory from '../pages/responsive-pages/authenticated/navigation-pages/mid-month/TelecomStory';
import StorySelector from '../pages/responsive-pages/authenticated/navigation-pages/mid-month/StorySelector';
import BalanceMoneyPage from '../pages/responsive-pages/authenticated/navigation-pages/balance-money/BalanceMoneyPage';
import PlanAheadPage from '../pages/responsive-pages/authenticated/navigation-pages/plan-ahead/PlanAheadPage';
import CreateChallengeWizard
  from '../pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/CreateChallengeWizard';
import ResetCashflow from '../pages/responsive-pages/authenticated/ResetCashflow.vue';

const { isNavigationFailure, NavigationFailureType } = Router;
const DISCOUNT_PROMO_CODE = 'discount';
const REDIRECT_TO_BLACKLIST = ['/login', '/signup', '/signup/details'];

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (!isNavigationFailure(err, NavigationFailureType.duplicated) && !isNavigationFailure(err, NavigationFailureType.redirected)) {
      throw err;
    }
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (!isNavigationFailure(err, NavigationFailureType.duplicated) && !isNavigationFailure(err, NavigationFailureType.redirected)) {
      throw err;
    }
  });
};

Vue.use(Router);

async function initCustomerState(to) {
  await Promise.all([
    store.dispatch('loader/startLoading', 'customerState'),
    store.dispatch('session/init', {
      incognito: to.query.incognito,
      name: to.name,
    }),
    store.dispatch('sourceFields/initSourceFields'),
    store.dispatch('discountPromotion/initDiscountPromotion'),
    store.dispatch('onboardingState/fetchOnboardingState'),
    store.dispatch('customerState/init'),
    store.dispatch('benefits/initBenefits'),
    store.dispatch('subscriptionState/initSubscriptionState'),
    store.dispatch('ambassadorsTouchPoints/init'),
    store.dispatch('tour/init'),
    store.dispatch('savings/initSavings'),
    store.dispatch('balance/init'),
    store.dispatch('credentials/fetchCredentials'),
    store.dispatch('credentials/fetchObkSourceConfigurations'),
  ]);
  await store.dispatch('loader/doneLoading', 'customerState');
}

function initWebSockets() {
  if (!Vue.prototype.$socket) {
    Vue.use(new VueSocketio({
      debug: false,
      connection: io(config.get().elsaPublicUrl, {
        path: '/websockets',
        transports: ['websocket', 'polling'],
        reconnectionAttempts: 3,
        autoConnect: false,
      }),
      vuex: {
        store,
        mutationPrefix: 'socket_',
      },
    }));
  }
  if (!Vue.prototype.$socket.connected) {
    Segment.trackUserGot('TempSocketConnect');
    Vue.prototype.$socket.connect();
  }
}

async function redirectToLogin(to, next) {
  const redirectTo = _extractRedirectTo(to.path);
  const isPartiallyLoggedIn = await LoginApi.isPartialLoggedIn();
  if (isPartiallyLoggedIn) {
    const member = await CustomersApi.getPartiallyAuthenticatedMember();
    if (member.hasOidc) {
      if (await _shouldShowGoogleDeadEndPage(member)) {
        const redirectPath = '/facebook-dead-end';
        Segment.trackUserGot('redirectingToFacebookDeadEnd', { redirectPath });
        const query = { ...to.query, redirectTo };
        next({ path: redirectPath, query });
      } else if (to.query.error_description === 'Access expired.') {
        const redirectPath = '/2fa-Link-Expired';
        Segment.trackUserGot('redirectingToResetPasswordLinkExpired', { redirectPath });
        next({ path: redirectPath });
      } else {
        Segment.trackUserGot('2faRedirectToAuth0Login');
        const redirectToForAuth0 = auth0.getEncodedRedirectTo(to);
        window.location.href = `/api/partial-auth/login-with-auth0?redirectTo=${redirectToForAuth0}`;
      }
      return;
    }
    Segment.trackUserGot('redirectTo2FaMigrationFromMain');
    window.location.href = '/2fa-migration';
    return;
  }
  const redirectPath = '/login';
  const query = { redirectTo, ...to.query };
  next({ path: redirectPath, query });
}

async function _shouldShowGoogleDeadEndPage(member) {
  const showFacebookDeadEndFeatureFlag = await featureFlag.getTreatmentPartialAuth('facebook-app-dead-end');
  return (showFacebookDeadEndFeatureFlag === 'on' && member.loginMethod
    && _.startsWith(member.loginMethod, 'google') && _isFacebookOrInstagramApp());
}

function _isFacebookOrInstagramApp() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return (userAgent.indexOf('FBAN') > -1) || (userAgent.indexOf('FBAV') > -1) || (userAgent.indexOf('Instagram') > -1);
}

function _extractRedirectTo(path) {
  if (_.includes(REDIRECT_TO_BLACKLIST, path)) {
    return 'sr';
  }
  return _.trimStart(path, '/');
}

const vueRouter = new Router({
  mode: 'history',
  routes: [
    {
      path: '/internal/playground',
      name: 'Playground',
      component: Playground,
    },
    {
      path: '/',
      name: 'ResponsivePage',
      component: ResponsivePage,
      children: [
        {
          path: '/signup',
          name: 'WineAndDineFlow',
          component: WineAndDineFlow,
          async beforeEnter(to, from, next) {
            // convert discount utm to promo code
            if (to.query.utm_source === 'Discount_app' && !to.query.promoCode) {
              const query = { promoCode: DISCOUNT_PROMO_CODE, ...to.query };
              next({ path: to.path, query });
            } else {
              next();
            }
          },
          props: route => {
            const props = {};
            if (route.query.refToken) {
              props.referralData = { householdName: route.query.hn, referralToken: route.query.refToken };
            }
            if (route.query.promoCode) {
              props.promoCode = route.query.promoCode;
            }
            return props;
          },
        },
        {
          path: '/signup/lq/vp/:componentName',
          name: 'LeadQualificationSurvey',
          component: LeadQualificationSurvey,
          props: route => {
            return { componentName: route.params.componentName, componentType: 'valueProp' };
          },
        },
        {
          path: '/signup/lq/finish',
          name: 'FinishLQ',
          component: FinishLQ,
        },
        {
          path: '/signup/lq/question/:componentName',
          name: 'LeadQualificationSurvey',
          component: LeadQualificationSurvey,
          props: route => {
            return { componentName: route.params.componentName, componentType: 'question' };
          },
        },
        {
          path: '/demo/',
          name: 'Demo',
          component: DemoCashflowApp,
        },
        {
          path: '/pocket-money',
          name: 'PocketMoney',
          component: PocketMoney,
        },
        {
          path: '/email-rendering',
          name: 'EmailRendering',
          component: EmailRendering,
        },
        {
          path: '/signup/details/v3',
          name: 'SignupV3',
          component: SignupFlowV3,
        },
        {
          path: '/signup/details/v2',
          name: 'SignupV2',
          component: SignupFlowV2,
        },
        {
          path: '/signup/details/v1',
          name: 'SignupV1',
          component: SignupFlowV1,
        },
        {
          path: '/signup/details',
          name: 'Signup',
          component: SignupFlow,
          props: route => {
            return { promoCode: route.query.promoCode };
          },
        },
        {
          path: '/goodbye',
          name: 'GoodbyePage',
          component: ChurnSurveyFlow,
        },
        {
          path: '/internal/login-as',
          name: 'LoginAs',
          component: LoginAs,
        },
        {
          path: '/login',
          name: 'Login',
          component: LoginEnterPhoneNumber,
        },
        {
          path: '/login-enter-code',
          name: 'LoginEnterCode',
          component: LoginEnterCode,
        },
        {
          path: '/invite',
          name: 'MemberInvite',
          component: InviteAuthenticateToken,
        },
        {
          path: '/shared/:sharePageId',
          name: 'SharedPage',
          component: SharedPage,
          props: route => {
            return {
              sharePageId: route.params.sharePageId,
            };
          },
        },
        {
          path: '/challenges/:ownerParticipantId/nli',
          name: 'JoinChallengeAsParticipant',
          component: ActiveChallengeRouter,
          props: route => {
            return {
              ownerParticipantId: route.params.ownerParticipantId,
              isAuthenticatedRoute: false,
            };
          },
        },
        {
          path: '/',
          name: 'SingleFactorAuthenticateToken',
          component: SingleFactorAuthenticateToken,
          redirect: { name: 'StateRouter' },
          async beforeEnter(to, from, next) {
            if (await LoginApi.isPartialLoggedIn()) {
              next();
            } else {
              const query = { redirectTo: _extractRedirectTo(to.path), ...to.query };
              next({ path: 'login', query });
            }
          },
          children: [
            {
              path: '/wrong-2fa-account-error',
              name: 'wrong2faAccountErrorScreen',
              component: Wrong2faAccountErrorScreen,
            },
            {
              path: '/complete-2fa-login',
              name: '2faLoginComplete',
              component: Complete2faLogin,
            },
            {
              path: '/add-2fa-done',
              name: '2faLoginDone',
              component: Done2FAScreen,
            },
            {
              path: '/2fa-migration',
              name: '2faMigration',
              component: TwoFactorMigration,
            },
            {
              path: '/signup-2fa-done',
              name: '2faSignupDone',
              component: Signup2faDoneScreen,
            },
            {
              path: '/2fa-Reset-Password',
              name: 'TwofaResetPassword',
              component: ResetPassword,
            },
            {
              path: '/2fa-Reset-Password-Sent',
              name: 'TwofaResetPasswordSent',
              component: ResetPasswordSent,
            },
            {
              path: '/2fa-Reset-Password-Done',
              name: 'TwofaResetPasswordDone',
              component: ResetPasswordDone,
            },
            {
              path: '/facebook-dead-end',
              name: 'LoginWithGoogleInFacebookBrowser',
              component: LoginWithGoogleOnFacebook,
            },
            {
              path: '/2fa-Link-Expired',
              name: 'TwofaResetPasswordExpiredLink',
              component: ResetPasswordLinkExpired,
            },
            {
              path: '/2fa-Reset-Password-Error',
              name: 'TwofaResetPasswordError',
              component: ResetPasswordError,
            },
          ],
        },
        {
          path: '/url-redirect',
          name: 'AuthenticateTokenRedirect',
          component: UrlRedirect,
          async beforeEnter(to, from, next) {
            if (await LoginApi.isLoggedIn()) {
              next();
            } else {
              await redirectToLogin(to, next);
            }
          },
        },
        {
          path: '/',
          name: 'AuthenticateToken',
          component: AuthenticateToken,
          redirect: { name: 'StateRouter' },
          async beforeEnter(to, from, next) {
            if (await LoginApi.isLoggedIn()) {
              await initCustomerState(to);
              initWebSockets();
              next();
            } else {
              await redirectToLogin(to, next);
            }
          },
          children: [
            {
              path: 'decode-and-redirect/:encodedUrl',
              name: 'DecodeAndRedirect',
              async beforeEnter(to, from, next) {
                const { path, params } = auth0.decodeUrl(to.params.encodedUrl);
                DDLogs.log('Redirecting path', { redirectedFrom: to.path });
                next({ path, query: params });
              },
            },
            {
              path: 'challenges',
              name: 'CreateChallengeWizard',
              component: CreateChallengeWizard,
            },
            {
              path: '/challenges/:ownerParticipantId',
              name: 'ActiveChallengeRouter',
              component: ActiveChallengeRouter,
              props: route => {
                return {
                  ownerParticipantId: route.params.ownerParticipantId,
                  isAuthenticatedRoute: true,
                };
              },
            },
            {
              path: 'reset-cashflow',
              name: 'ResetCashflow',
              component: ResetCashflow,
            },
            {
              path: '/',
              name: 'AppHeader',
              component: AppHeader,
              children: [
                {
                  path: '/',
                  name: 'PopupsManager',
                  component: PopupsManager,
                  props: route => {
                    return { hideCta: Boolean(route.query.hideCta) };
                  },
                  async beforeEnter(to, from, next) {
                    if (await isDormantWinback()) {
                      next({ path: 'reset-cashflow', query: to.query });
                    } else {
                      next();
                    }
                  },
                  children: [
                    {
                      path: 'home',
                      name: 'Home',
                      component: CashflowApp,
                    }, {
                      path: 'cashflow-app',
                      name: 'CashflowApp',
                      component: CashflowApp,
                    }, {
                      path: 'balance',
                      name: 'BalancePage',
                      component: BalancePage,
                    }, {
                      path: 'credentials',
                      name: 'CredentialsSettings',
                      component: CredentialsSettings,
                      meta: {
                        routerBack: true,
                      },
                    }, {
                      path: 'settings',
                      name: 'Settings',
                      component: Settings,
                    }, {
                      path: 'personal-info',
                      name: 'PersonalInformation',
                      component: PersonalInformation,
                      meta: {
                        routerBack: true,
                      },
                    }, {
                      path: 'stories',
                      name: 'TransactionStories',
                      component: TransactionStories,
                    }, {
                      path: 'account-settings',
                      name: 'AccountSettings',
                      component: AccountSettings,
                      meta: {
                        routerBack: true,
                      },
                    }, {
                      path: 'saving-zone',
                      name: 'SavingZone',
                      component: SavingZone,
                    }, {
                      path: 'balance-money',
                      name: 'BalanceMoneyPage',
                      component: BalanceMoneyPage,
                    }, {
                      path: 'plan-ahead',
                      name: 'PlanAheadPage',
                      component: PlanAheadPage,
                      async beforeEnter(_, __, next) {
                        if (await featureFlag.getTreatment('elsa-show-plan-ahead-page') === 'on') {
                          next();
                        } else {
                          next({ path: '/sr' });
                        }
                      },
                    }, {
                      path: 'moneymoon_join',
                      name: 'MoneyMoonJoin',
                      component: MoneyMoonJoinPage,
                    }, {
                      path: 'riseup-giftcard',
                      name: 'RiseupGiftcard',
                      component: RiseupGiftcardFlow,
                    }, {
                      path: 'super-discount',
                      name: 'SuperDiscount',
                      component: SuperDiscountPage,
                    }, {
                      path: '/s/token',
                      name: 'DiscountConnectionApprovedPage',
                      component: DiscountConnectionApprovedPage,
                    },
                  ],
                }, {
                  path: 'tour',
                  name: 'Tour',
                  component: CashflowTourFlow,
                  async beforeEnter(to, from, next) {
                    if (await isDormantWinback()) {
                      next({ path: 'reset-cashflow' });
                    } else {
                      next();
                    }
                  },
                }, {
                  path: 'mr',
                  name: 'MonthReview',
                  component: MonthReviewFlowWrapper,
                }, {
                  path: 'ambassadors',
                  name: 'Ambassadors',
                  component: AmbassadorsPage,
                  props: route => {
                    return {
                      showIdPopup: Boolean(route.query.shouldEnterId),
                    };
                  },
                },
              ],
            },
            {
              path: '/st/:storyName',
              name: 'StorySelector',
              component: StorySelector,
              props: route => {
                return {
                  storyName: route.params.storyName,
                };
              },
            }, {
              path: 'telecom-story',
              name: 'TelecomStory',
              component: TelecomStory,
              async beforeEnter(to, from, next) {
                Segment.trackUserInteraction('TelecomStoryExpiredEntered');
                next({ path: '/sr' });
              },
            }, {
              path: 'supermarket-story',
              name: 'SupermarketStory',
              component: SupermarketStory,
              async beforeEnter(to, from, next) {
                if (await featureFlag.getTreatment('elsa-supermarket-story') === 'on') {
                  next();
                } else {
                  next({ path: '/sr' });
                }
              },
            },
            {
              path: 'supermarket-story-teaser',
              name: 'SupermarketStoryTeaser',
              component: SupermarketStoryTeaser,
            },
            {
              path: 'ybitan',
              beforeEnter() {
                window.location.href = 'https://intercom.riseup.co.il/he/articles/6527821-לקנות-ב-יינות-ביתן-בהנחה-דרך-רייזאפ';
              },
            },
            {
              path: 'sr',
              name: 'StateRouter',
              component: StateRouter,
            }, {
              path: 'group-join', // in app
              name: 'SuspiciousGroupJoinInvestigator',
              component: SuspiciousGroupJoinInvestigator,
            }, {
              path: '/invite-member',
              name: 'InviteMember',
              component: InviteMember,
              props: route => {
                return { autoRedirect: route.query.redirect === 'true' };
              },
            }, {
              path: 'unsupported-banks', // in app
              name: 'UnsupportedBanks',
              component: UnsupportedBanksMessagePage,
            }, {
              path: 'subscription', // out of app
              name: 'subscription',
              component: SubscriptionFlow,
              meta: {
                preventRouterBack: true,
              },
            },
            {
              path: 'survey',
              name: 'Survey',
              component: Survey,
              children: [
                {
                  path: 'first-cashflow', // in app
                  name: 'First Cashflow Survey',
                  component: ActivationSurvey,
                },
                {
                  path: 'csat', // in app
                  name: 'CSAT Survey',
                  component: CSATSurvey,
                },
                {
                  path: 'nps',
                  name: 'NPS survey',
                  component: NPSSurveyFlow,
                },
              ],
            },
            {
              path: '/ob',
              name: 'Onboard',
              component: OnboardFlow,
            },
            {
              path: '/discount/welcome-back',
              name: 'DiscountLandingPage',
              component: DiscountLandingPage,
            },
            {
              path: '/discount/welcome-back/:state/:error/:refreshed',
              async beforeEnter(to, from, next) {
                const { state, error, refreshed } = to.params;
                next({ path: '/discount/welcome-back', query: { ...to.query, state, error, refreshed } });
              },
            },
            {
              path: '/:source/welcome-back',
              name: 'OpenBankingLandingPage',
              component: OpenBankingLandingPage,
              meta: {
                preventRouterBack: true,
              },
            },
            {
              path: 'loading-credentials',
              name: 'LoadingOBKCredentials',
              component: LoadingOBKCredentials,
              meta: {
                preventRouterBack: true,
              },
            },
            // This path is because auth0 returns only one query param so we send the state
            // as part of the url
            {
              path: '/:source/welcome-back/:consentId/:code',
              async beforeEnter(to, from, next) {
                const { consentId, source, code } = to.params;
                next({ path: `/${source}/welcome-back`, query: { ...to.query, state: consentId, code } });
              },
            },
            {
              path: '*',
              redirect: { name: 'AuthenticateToken' },
            },
          ],
        },
      ],
    },
  ],
});

// We want our "back" arrow in the app to go to previous place in app.
// However, if it's the first page, we don't want to go back to previous site or empty tab.
// Turns out that the router history does not expose the previous paths and if we want to check
// which page we came from we need to hook and record it ourselves.
// This puts the previous route name on the meta field of each route.
// The first page we came from will have a null value since the 'from.name' is empty.
vueRouter.beforeEach((to, from, next) => {
  _.extend(to.meta, { previousRoute: from });
  next();
});

export default vueRouter;
